function isValidUrl(string) {
  try {
    new URL(string)
    return true
  } catch {
    return false
  }
}

export default function RedirectAction({ actionId }) {
  const action = useSel(s => s.taker.flow.actions.find(a => a.id === actionId) || {})
  const { config } = action
  const redirectUrl = config?.redirectUrl

  const isValid = isValidUrl(redirectUrl)

  useEffect(() => {
    if (isValid) {
      window.location.href = redirectUrl
    }
  }, [isValid, redirectUrl])

  if (!isValid) {
    return <div>Invalid redirect URL</div>
  }

  return <div>
    Redirecting...
  </div>
}
